<template>
  <div class="from_box flex">
    <div class="item">
      <span class="txt">物料编码：</span>
      <el-autocomplete
        v-model="fromData.materialCode"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入物料编码"
        @select="handleSelect"
      ></el-autocomplete>
    </div>

    <div class="item">
      <span class="txt">工厂：</span>
      <el-select v-model="fromData.factoryId" @change="changeFactory" placeholder="请选择工厂">
        <el-option
          v-for="item in factoryList"
          :label="item.value"
          :key="item.factoryId"
          :value="item.factoryId"
        ></el-option>
      </el-select>
    </div>

    <div class="item">
      <span class="txt">基本数量：</span>
      <el-input v-model="fromData.basicNum" :clearable="true" placeholder="暂无基本数量"></el-input>
    </div>

    <!-- <div class="item">
      <span class="txt">基本计量单位：</span>
      <el-select v-model="fromData.unitId" @change="changEvent" placeholder="请选择计量单位">
        <el-option
          v-for="item in targetUnitList"
          :label="item.value"
          :key="item.unitId"
          :value="item.unitId"
        ></el-option>
      </el-select>
    </div> -->
    
    <div class="item">
      <span class="txt">基本计量单位：</span>
      <el-input v-model="fromData.bomBasicUnitName" placeholder="暂无基本计量单位"></el-input>
    </div>

    <!-- <div class="item">
      <span class="txt">BOM版本：</span>
      <el-input v-model="fromData.bomClassifyCode" placeholder="暂无BOM版本"></el-input>
    </div> -->

    <div class="item">
      <span class="txt">BOM状态：</span>
      <el-input v-model="fromData.bomStatus" placeholder="暂无BOM状态"></el-input>
    </div>

    <div class="item">
      <span class="txt">有效起始日：</span>
      <el-date-picker v-model="fromData.startDate" type="date" placeholder="选择日期"></el-date-picker>
    </div>

    <div class="item">
      <span class="txt">批量：从</span>
      <el-input v-model="fromData.fromBatch" placeholder="请输入"></el-input>
    </div>

    <div class="item">
      <span class="txt">到：</span>
      <el-input v-model="fromData.toBatch" placeholder="请输入"></el-input>
    </div>

    <div class="item">
      <span class="txt" style="margin-left:-4.5%">删除标记：</span>
      <el-checkbox style="margin-top:8px" v-model="removeMark"></el-checkbox>
    </div>
    <div class="coll list_content">
				<h2><span>备注长文本：</span></h2>
				<el-input
				style="margin-top:10px"
				type="textarea"
                maxlength="40"
				:rows="2"
				placeholder="请输入内容，长度不能超过40"
				v-model="fromData.optionBomTxt">
				</el-input>
		</div>
  </div>
</template>

<script>
import { fstockApi, customerApi, bomApi, matterApi } from "api/base.js";
import { targetUnit } from "api/business.js";

export default {
  components: {},
  props: {
    fromData: Object,
    noFromData: Object,
    factoryList: Array,
    targetUnitList: Array
  },
  data() {
    return {
      restaurants: [],
      timeout: null,
      removeMark: false,
      downloadUrl:
        "http://192.168.2.249:8080/purchasemng/purchaseinstock/excel/tpl",
      uploadUrl:
        "http://192.168.2.249:8080/purchasemng/purchaseinstock/excel/importmaterial"
    };
  },
  created() {
    //有效起止日默认今天
    let nowData = new Date();
    this.$set(this.fromData, "startDate", nowData);
  },
  methods: {
    async loadAll() {
      let res = await this.$post(matterApi.list, this.$store.state.getAllPage);
      if(res.status){
        let materialList = []
        res.data.list.forEach((item)=>{
          item.value = item.materialCode + "-" + item.materialDesc;
          materialList.push(item)
        });
        this.restaurants = materialList;
        
      }else{
        console.log(res.error)
      }
    },
    querySearchAsync(queryString, cb) {
      let list = this.restaurants;
      console.log(list,'=====');
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(list);
      }, 1500 * Math.random());
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.materialCode.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(item) {
      console.log(item);
      this.fromData.materialId = item.materialId;
      this.fromData.materialCode = item.materialCode;
      this.fromData.materialDesc = item.materialDesc;

      this.fromData.bomBasicUnitId = item.basicUnitId
      this.fromData.bomBasicUnit = item.basicUnitCode
      this.fromData.bomBasicUnitName = item.basicUnitDesc

    },

    //计量单位改变
    // changEvent(val) {
    //   console.log(this.fromData);
    //   let obj = this.targetUnitList.find(v => v.unitId === val);
    //   if (obj) {
    //     this.fromData.compUnitId = obj.unitId;
    //     this.fromData.compUnitCode = obj.unitCode;
    //     this.fromData.compUnitDesc = obj.unitDesc;
    //   }
    // },
    
    //工厂修改
    changeFactory(val) {
      console.log(this.factoryList);
      let obj = this.factoryList.find(v => v.factoryId === val);
      if (obj) {
        this.fromData.factoryId = obj.factoryId;
        this.fromData.factoryCode = obj.factoryCode;
        this.fromData.factoryDesc = obj.factoryDesc;
      }
    },
    //获取物料BOM版本号
    // async getBomdefine() {
    //   let detail = await this.$post(bomApi.bomdefine, {
    //     companyId: 0,
    //     materialId: 0
    //   });
    //   console.log(detail);
    //   if (detail.status) {
        
    //   }
    // }
  },
  mounted() {
    this.restaurants = this.loadAll();
  }
};
</script>

<style>
</style>
